module.exports = __webpack_public_path__ + "static/media/eroban.5ed16f2b.jpg";